import { Routes } from '@angular/router';

import { Login } from './features/login/login';
import { Layout } from './shared/components/layout/layout';
import { ForgotPassword } from './features/forgot-password/forgot-password';
import { Transactions } from './features/transactions/transactions';
import { ActivityStatus } from './features/activity-status/activity-status';
import { ChangePassword } from './features/change-password/change-password';
import { authGuard } from './core/guards/auth-guard';
import { loginGuard } from './core/guards/login-guard';
import { Cards } from './features/cards/cards';
import { Settings } from './features/settings/settings';
import { HelpCenter } from './features/help-center/help-center';
import { Onboarding } from './features/onboarding/onboarding';
import { Notifications } from './features/notifications/notifications';

export const routes: Routes = [
  // Public route 
  { path: '', component: Login, canActivate: [loginGuard] },


  // Layout wrapper for internal pages
  {
    path: '',
    component: Layout,
    children: [
      // Public page
      { path: 'forgot-password', component: ForgotPassword },
      { path: 'onboarding', component: Onboarding },

      // Protected routes
      {
        path: '',
        canActivateChild: [authGuard],
        children: [
          { path: 'change-password', component: ChangePassword },
          {
            path: 'accounts',
            loadChildren: () =>
              import('./features/accounts/accounts.routes').then(m => m.accountsRoutes)
          },
          { path: 'transactions', component: Transactions },
          { path: 'cards', component: Cards },
          { path: 'user-management', loadChildren: () => import('./features/user-management/user-management.routes').then(m => m.userManagementRoutes) },
          { path: 'activity-status', component: ActivityStatus },
          { path: 'settings', component: Settings },
          { path: 'notifications', component: Notifications },
          { path: 'help-center', component: HelpCenter },
          { path: 'cliq-beneficiaries', loadChildren: () => import('./features/cliq-beneficiaries/cliq-beneficiaries.routes').then(m => m.cliqBeneficiariesRoutes) },
          {
            path: '',
            loadChildren: () => import('./features/cliq-alias/cliq-alias.routes').then(m => m.cliqAliasRoutes)
          },
              {
            path: '',
            loadChildren: () => import('./features/send-request-cliq/send-request-cliq.routes').then(m => m.cliqSendRequest)
          },
          { path: 'bill-payments', loadChildren: () => import('./features/bill-payments/bill-payments.routes').then(m => m.billPaymentsRoutes) },
          { path: 'cash-push', loadChildren: () => import('./features/cash-push-pull/cash-push-pull.routes').then(m => m.cashPushPullRoutes) },
          { path: 'cash-pull', loadChildren: () => import('./features/cash-push-pull/cash-push-pull.routes').then(m => m.cashPushPullRoutes) }
        ],
      },

    ],
  },

  // Redirect any unknown route to login
  { path: '**', redirectTo: '' },
];
